<template>
  <!-- Wrap UtilAccordianItems with a <div class="accordian"> -->
  <div :class="{ 'is-active': isActive }" class="accordian-item">
    <div class="accordian-tab flex justify-between items-center" @click="toggleOpen()">
      <span class="font-medium ">
        <slot name="title" />
      </span>
      <span>
        <FontAwesomeIcon v-if="isActive" :icon="faChevronUp" />
        <FontAwesomeIcon v-else :icon="faChevronDown" />
      </span>
    </div>

    <div class="accordian-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'UtilAccordianItem',
  props: {
    startActive: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      faChevronDown,
      faChevronUp,
      isActive: false
    }
  },
  created() {
    if (this.startActive) {
      this.toggleOpen()
    }
  },
  methods: {
    toggleOpen() {
      this.isActive = !this.isActive
    }
  }
}
</script>

<style lang="scss">
  .accordian-item {
    @apply w-full;

    &.is-active {
      .accordian-tab {
        border: none;
      }

      .accordian-content {
        display: block;
      }
    }
    
    &:first-of-type {
      .accordian-tab {
        @apply rounded-t-xl;
      }
    }

    &:last-of-type:not(.is-active) {
      .accordian-tab {
        @apply rounded-b-xl;
      }
    }

    &:last-of-type {
      .accordian-tab {
        border: none;
      }

      .accordian-content {
        @apply rounded-b-xl;
      }
    }
  }

  .accordian-tab {
    @apply bg-background p-4 w-full cursor-pointer select-none;
    border-bottom: 1px solid rgb(189,189,189, 0.3);
  }

  .accordian-content {
    @apply border-background border w-full p-6 border-t-0;
    display: none;
  }
</style>